import { render, staticRenderFns } from "./linkman.vue?vue&type=template&id=1fde3eaa&scoped=true&"
import script from "./linkman.vue?vue&type=script&lang=js&"
export * from "./linkman.vue?vue&type=script&lang=js&"
import style0 from "./linkman.vue?vue&type=style&index=0&id=1fde3eaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fde3eaa",
  null
  
)

export default component.exports